import React from 'react';

const withTeamsUserType = <T,>(
	Component: React.FC<T>
) => (props: T) => <Component {...props} isTeamUser />;

export default withTeamsUserType;
